import WebLayout from "../layout/WebLayout";
import { Link } from "react-router-dom";

function Contact() {
  return (
    <WebLayout pageName={Contact}>
      <section className="contact py-40">
        <div className="container container-lg">
          <div className="row gy-5">
            <div className="col-lg-8">
              <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                <form action="#">
                  <h6 className="mb-32">Give Us a Message</h6>
                  <div className="row gy-4">
                    <div className="col-sm-6 col-xs-6">
                      <label
                        for="name"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Name{" "}
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        className="common-input px-16"
                        id="name"
                        placeholder="Full name"
                      />
                    </div>
                    <div className="col-sm-6 col-xs-6">
                      <label
                        for="email"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Email{" "}
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="email"
                        className="common-input px-16"
                        id="email"
                        placeholder="Email address"
                      />
                    </div>
                    <div className="col-sm-6 col-xs-6">
                      <label
                        for="phone"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Mobile Number
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="number"
                        className="common-input px-16"
                        id="phone"
                        placeholder="Phone Number*"
                      />
                    </div>
                    <div className="col-sm-6 col-xs-6">
                      <label
                        for="subject"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Subject{" "}
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        className="common-input px-16"
                        id="subject"
                        placeholder="Subject"
                      />
                    </div>
                    <div className="col-sm-12">
                      <label
                        for="message"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Message{" "}
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>{" "}
                      </label>
                      <textarea
                        className="common-input px-16"
                        id="message"
                        placeholder="Type your message"
                      ></textarea>
                    </div>
                    <div className="col-sm-12 mt-32">
                      <button
                        type="submit"
                        className="btn btn-main py-18 px-32 rounded-8"
                      >
                        Get a Quote
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                <h6 className="mb-48">Get In Touch</h6>
                <div className="flex-align gap-16 mb-16">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-map-pin"></i>
                  </span>
                  <p className="text-md text-gray-900 hover-text-main-600">
                    <b>Head Office:</b> C 7/82, Sector 8, Rohini, New Delhi -
                    110085
                  </p>
                </div>
                <div className="flex-align gap-16 mb-16">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-phone-call"></i>
                  </span>
                  <Link
                    to="tel:8800001259"
                    className="text-md text-gray-900 hover-text-main-600"
                  >
                    +91-8800001259
                  </Link>
                </div>
                <div className="flex-align gap-16 mb-16">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-phone-call"></i>
                  </span>
                  <Link
                    to="tel:9990060509"
                    className="text-md text-gray-900 hover-text-main-600"
                  >
                    +91-9990060509
                  </Link>
                </div>
                <div className="flex-align gap-16 mb-16">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-envelope"></i>
                  </span>
                  <Link
                    to="mailto:help@indianmsme.org"
                    className="text-md text-gray-900 hover-text-main-600"
                  >
                    help@indianmsme.org
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </WebLayout>
  );
}

export default Contact;
